export { default as ContentfulVideo } from "./ContentfulVideo";
